module.exports = __webpack_public_path__ + "static/media/20180523-LCS-002-18.a6e8a201.jpg";